import { ReportType } from '../../core/api/clients';

export const getFormName = (reportType: ReportType | undefined) => {
  switch (reportType) {
    case ReportType.CabinEventReport:
      return 'cabin-event';
    case ReportType.FlightEventReport:
      return 'flight-event';
    case ReportType.DispatchEventReport:
      return 'dispatch-event';
    case ReportType.SafetyEventReport:
      return 'safety-event';
    default: return '';
  }
};

export const getAvatarText = (reportType: ReportType | undefined) => {
  switch (reportType) {
    case ReportType.CabinEventReport:
      return 'CER';
    case ReportType.FlightEventReport:
      return 'FER';
    case ReportType.DispatchEventReport:
      return 'DER';
    case ReportType.SafetyEventReport:
      return 'SER';
    default: return '';
  }
};
